<template>
  <v-text-field
    v-model="date"
    type="datetime-local"
    v-bind="$attrs"
    v-on="$listeners"
    :data-testid="dataTestid"
  />
</template>

<script>
import Format from "@/mixins/Format";

export default {
  mixins: [Format],

  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      date: this.toLocalDate(this.value),
    };
  },

  watch: {
    value() {
      this.date = this.toLocalDate(this.value);
    },
    date() {
      const iso = this.toISOString(this.date);
      if (iso !== this.value) {
        this.$emit("input", iso);
      }
    },
  },
};
</script>

